/** A snap keeps the video's full width, not just the on-screen guide (SGL-594).
 *  The preview is object-cover in a tall box, so a landscape camera (a laptop
 *  webcam, or any camera on a narrow screen) loses its sides on screen, and the
 *  guide is narrower still. Cropping to the guide cut through a card held at a
 *  natural distance: the model read "cus Webb" and "s.webbroofing@yahoo.com".
 *  A fixed margin around the guide was not enough at phone width, so the width
 *  is the whole frame and only the height is limited, to a band around the
 *  guide. Focus and steadiness are still measured inside the guide. */

/** Band height as a fraction of the frame width: a card is 1.75:1, so this
 *  leaves room above and below a card that spans the whole width. */
const BAND_HEIGHT_OF_WIDTH = 1 / 1.4;
/** And never less than this many guide heights. */
const MIN_GUIDE_HEIGHTS = 2;

export interface SourceRect {
  sx: number;
  sy: number;
  sw: number;
  sh: number;
}

/** The region of the video a snap sends to the model: full width, and a band
 *  of height centred on the guide, clamped to the video. */
export function captureRect(guide: SourceRect, vw: number, vh: number): SourceRect {
  const sh = Math.min(vh, Math.max(vw * BAND_HEIGHT_OF_WIDTH, guide.sh * MIN_GUIDE_HEIGHTS));
  const cy = guide.sy + guide.sh / 2;
  const sy = Math.max(0, Math.min(cy - sh / 2, vh - sh));
  return { sx: 0, sy, sw: vw, sh };
}
